export const symbolList = {
  0: [
    {
      operatorCnName: 'pc_spmodel_eq_7',
      operateType: 7
    },
    {
      operatorCnName: 'pc_spmodel_eq_8',
      operateType: 8
    },
    // {  // 指标无法全部
    //   operatorCnName: 'pc_spmodel_eq_9',
    //   operateType: 9
    // },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_equal',
      operateType: 1
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_more_than',
      operateType: 3
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_less_than',
      operateType: 4
    },
    {
      operatorCnName: 'pc_spmodel_eq_5',
      operateType: 5
    },
    {
      operatorCnName: 'pc_spmodel_eq_6',
      operateType: 6
    }
  ],
  1: [
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_equal',
      operateType: 1
    },
    {
      operatorCnName: 'pc_spmodel_eq_2',
      operateType: 2
    },
    {
      operatorCnName: 'pc_spmodel_eq_10',
      operateType: 10
    },
    {
      operatorCnName: 'pc_spmodel_eq_11',
      operateType: 11
    }
  ],
  2: [
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_equal',
      operateType: 1
    },
    {
      operatorCnName: 'pc_spmodel_eq_2',
      operateType: 2
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_more_than',
      operateType: 3
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_less_than',
      operateType: 4
    },
    {
      operatorCnName: 'pc_spmodel_eq_5',
      operateType: 5
    },
    {
      operatorCnName: 'pc_spmodel_eq_6',
      operateType: 6
    },
    {
      operatorCnName: 'pc_spmodel_eq_14',
      operateType: 20 // 区间处理成大于等于+小于等于传给后端
    }
  ],
  3: [
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_equal',
      operateType: 1
    },
    {
      operatorCnName: 'pc_spmodel_eq_2',
      operateType: 2
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_more_than',
      operateType: 3
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_less_than',
      operateType: 4
    },
    {
      operatorCnName: 'pc_spmodel_eq_5',
      operateType: 5
    },
    {
      operatorCnName: 'pc_spmodel_eq_6',
      operateType: 6
    },
    {
      operatorCnName: 'pc_spmodel_eq_14',
      operateType: 20
    }
  ],
  4: [
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_equal',
      operateType: 1
    },
    {
      operatorCnName: 'pc_spmodel_eq_2',
      operateType: 2
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_more_than',
      operateType: 3
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_less_than',
      operateType: 4
    },
    {
      operatorCnName: 'pc_spmodel_eq_5',
      operateType: 5
    },
    {
      operatorCnName: 'pc_spmodel_eq_6',
      operateType: 6
    },
    {
      operatorCnName: 'pc_spmodel_eq_14',
      operateType: 20
    }
  ],
  5: [
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_equal',
      operateType: 1
    },
    {
      operatorCnName: 'pc_spmodel_eq_2',
      operateType: 2
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_more_than',
      operateType: 3
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_less_than',
      operateType: 4
    },
    {
      operatorCnName: 'pc_spmodel_eq_5',
      operateType: 5
    },
    {
      operatorCnName: 'pc_spmodel_eq_6',
      operateType: 6
    },
    {
      operatorCnName: 'pc_spmodel_eq_14',
      operateType: 20
    }
  ]
};

export const laberlist = {
  1: [
    {
      operatorCnName: 'pc_spmodel_eq_7',
      operateType: 7
    },
    {
      operatorCnName: 'pc_spmodel_eq_8',
      operateType: 8
    },
    {
      operatorCnName: 'pc_spmodel_eq_9',
      operateType: 9
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_equal',
      operateType: 1
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_more_than',
      operateType: 3
    },
    {
      operatorCnName: 'pc_gwnl_lbl_dimension_less_than',
      operateType: 4
    },
    {
      operatorCnName: 'pc_spmodel_eq_5',
      operateType: 5
    },
    {
      operatorCnName: 'pc_spmodel_eq_6',
      operateType: 6
    }
  ]
};
